module.exports = __webpack_public_path__ + "src/assets/User-Template.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/User-Template.csv
// module id = 1744
// module chunks = 0